import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["zone", "input", "hint", "filename"]

  dragover(e) {
    e.preventDefault()
    this.zoneTarget.dataset.active = "true"
  }

  dragleave(e) {
    if (!this.zoneTarget.contains(e.relatedTarget)) {
      delete this.zoneTarget.dataset.active
    }
  }

  drop(e) {
    e.preventDefault()
    delete this.zoneTarget.dataset.active
    const files = e.dataTransfer.files
    if (files.length > 0) {
      this.inputTarget.files = files
      this.#picked(files[0].name)
    }
  }

  change() {
    const file = this.inputTarget.files[0]
    if (file) this.#picked(file.name)
  }

  #picked(name) {
    this.filenameTarget.textContent = name
    this.hintTarget.textContent = "Wysyłanie…"
    this.zoneTarget.dataset.uploading = "true"
    this.element.closest("form").submit()
  }
}
